import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extraSpaceAfterComma'
})
export class ExtraSpaceAfterCommaPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    // Replace every comma (,) with a comma followed by a space, ensuring no duplicate spaces
    return value.toString().replace(/,(\S)/g, ', $1');
  }
}
